'use strict';

var _ = require('lodash');
var OverridesUtilsService = function OverridesUtilsService($rootScope, constants, scenarioConstants) {
  //transform segment type to int
  // if mapping isn`t found return -1
  var userSegmentTypes = {
    BOTH: 0,
    LOCAL: 1,
    CONNECT: 2,
    get: function get(key) {
      return this[key] === 0 ? this[key] : this[key] || -1;
    }
  };
  var customUserFieldsMap = {
    'seasonOverride': 'userSeasonOverride'
  };
  var customValueTypeColumnMap = {
    'userAllocationType': 'userAllocationType'
  };
  var epsilon = 0.000001;
  function prefixNestedField(fieldName) {
    var field = getOriginalFieldName(fieldName);
    if (field === 'remainingDemandFC') {
      return ['demand', field].join('.');
    }
    return field;
  }
  function getEffectiveFieldName(userField) {
    return constants.EFFECTIVE_PREFIX + _.upperFirst(getRootFieldName(userField));
  }
  function getBaseFieldName(userField) {
    return constants.BASE_PREFIX + _.upperFirst(getRootFieldName(userField));
  }
  function getFlowType(fieldName) {
    if (fieldName.match(constants.IS_MAPPED)) {
      return 'MAPPED';
    }
    if (fieldName.match(constants.IS_REGULAR)) {
      return 'REGULAR';
    }
    if (fieldName === constants.HARD_OVERRIDE_TYPE || fieldName === constants.LINK_TYPE) {
      return 'REGULAR';
    }
    if (fieldName === constants.HARD_OVERRIDE_TYPE || fieldName === constants.LINK_TYPE) {
      return 'REGULAR';
    }
  }
  function isValidStartRtpOverride(row) {
    return _.reduce(constants.RTP_TO_DEMAND_FIELD_MAP, function (result, demandField, rtpField) {
      var rtpEdited = !_.isNil(row[rtpField]) && _.has(row._old, rtpField) && row[rtpField] !== row._old[rtpField];
      var matchingDemandEmpty = _.isNil(row[demandField]) && !_.has(row._old, demandField);
      if (rtpEdited && matchingDemandEmpty) {
        return false;
      }
      return result;
    }, true);
  }
  function validateStartRtpOverrides(gridData) {
    return _.reduce(gridData, function (result, row) {
      if (isValidStartRtpOverride(row)) {
        return result;
      } else {
        return false;
      }
    }, true);
  }
  function getRtpField(input) {
    return constants.DEMAND_TO_RTP_FIELD_MAP[input];
  }
  function getDemandField(input) {
    return constants.RTP_TO_DEMAND_FIELD_MAP[input];
  }
  function isRtpField(input) {
    return !!getDemandField(input);
  }
  function isValueType(input) {
    return _.startsWith(input, constants.USER_TYPE_PREFIX);
  }
  function isUserSegmentLimit(key) {
    return key === constants.USER_SEGMENT_LIMIT;
  }
  function isUserSegmentLimitType(key) {
    return key === constants.USER_SEGMENT_LIMIT_TYPE;
  }
  function isManuallyControlled(key) {
    return key === constants.IS_MANUALLY_CONTROLLED;
  }
  function isInvalidOverrideField(input) {
    return isEffective(input) || isRtpField(input);
  }
  function isEffective(input) {
    return _.startsWith(input, constants.EFFECTIVE_PREFIX);
  }
  function isUserField(userField) {
    userField = customUserFieldsMap[userField] || userField;
    return _.startsWith(userField, constants.USER_PREFIXES[1]);
  }
  function getRootFieldName(userField) {
    return userField.replace(constants.STRIP_USER, '');
  }
  function getRootFieldNamePublic(userField) {
    return _.lowerFirst(userField.replace(constants.STRIP_USER, ''));
  }
  function getOriginalFieldName(userField) {
    return _.lowerFirst(getRootFieldName(userField).replace(constants.STRIP_FLOW_TYPE, ''));
  }
  function handleSegmentLimitType(row, key) {
    return userSegmentTypes.get(row[key]);
  }
  function authLinkType(key) {
    return key === constants.AUTH_LINK || key === constants.AVAIL_LINK || key === constants.REGULAR_AUTH_LINK || key === constants.REGULAR_AVAIL_LINK;
  }
  function isAuthOverride(key) {
    return key === constants.USER_MIN_AUTHORIZATION || key === constants.USER_MAX_AUTHORIZATION || key === constants.USER_REGULAR_MIN_AUTHORIZATION || key === constants.USER_REGULAR_MAX_AUTHORIZATION || key === constants.USER_SEG_CLASS_MIN_AUTHORIZATION || key === constants.USER_SEG_CLASS_MAX_AUTHORIZATION;
  }
  function overrideMaxType(key) {
    return key === constants.USER_MAX_AVAILABILITY || key === constants.USER_MAX_AUTHORIZATION || key === constants.USER_REGULAR_MAX_AVAILABILITY || key === constants.USER_REGULAR_MAX_AUTHORIZATION || key === constants.USER_SEG_CLASS_MAX_AVAILABILITY || key === constants.USER_SEG_CLASS_MAX_AUTHORIZATION;
  }
  function overrideMinType(key) {
    return key === constants.USER_MIN_AVAILABILITY || key === constants.USER_MIN_AUTHORIZATION || key === constants.USER_REGULAR_MIN_AVAILABILITY || key === constants.USER_REGULAR_MIN_AUTHORIZATION || key === constants.USER_SEG_CLASS_MIN_AVAILABILITY || key === constants.USER_SEG_CLASS_MIN_AUTHORIZATION;
  }
  function getAdjacentOverrideKey(key) {
    return constants.ADJACENT_TYPES_MAP[key];
  }
  function handleZeroValue(row, key) {
    var value = row[key];
    return _.isBoolean(value) || value === 0 ? value : value || '';
  }
  function getValueTypePublic(row, fieldName) {
    return getValueType(row, getRootFieldName(fieldName));
  }
  function getValueType(row, rootName) {
    return row[constants.USER_TYPE_PREFIX + rootName];
  }
  function getTypeValuePublic(row, fieldName) {
    return getTypeValue(row, getRootFieldName(fieldName));
  }
  function getTypeValue(row, rootName) {
    return row[constants.USER_VALUE_PREFIX + rootName];
  }
  function getOverrideValue(row, rootName) {
    return row[constants.USER_PREFIXES[0] + rootName] || row[constants.USER_PREFIXES[1] + rootName];
  }
  function getCalculatedValue(row, rootName) {
    return row[constants.CALCULATED_PREFIX + rootName];
  }
  function getModelValue(row, rootName) {
    return row[_.lowerFirst(rootName)];
  }
  function getValueTypeColumn(userField) {
    if (customValueTypeColumnMap[userField]) {
      return customValueTypeColumnMap[userField];
    }
    var rootFieldName = _.upperFirst(getRootFieldName(userField));
    return constants.USER_TYPE_PREFIX + rootFieldName;
  }
  function getValues(row, userField) {
    var rootFieldName = _.upperFirst(getRootFieldName(userField));
    return {
      model: getModelValue(row, rootFieldName),
      user: getOverrideValue(row, rootFieldName),
      type: getValueType(row, rootFieldName),
      calculated: getCalculatedValue(row, rootFieldName),
      factor: getRtpFactor(row, rootFieldName)
    };
  }
  function getRtpFactor(row, fieldName) {
    var rtpFieldName = constants.START_RTP_PREFIX + _.upperFirst(fieldName);
    var startRtp = row[rtpFieldName];
    if (_.isNil(startRtp)) {
      return;
    }
    startRtp += epsilon;
    if (!_.isNil(row.daysToDeparture)) {
      var dtd = row.daysToDeparture;
      return Math.min(1, dtd / startRtp);
    }
  }
  function isSaveStatusCorrect(saveStatusList, index) {
    var areThereMoreAttributesThanResponses = index > saveStatusList.length - 1;
    var areAllResponsesTrue = !_.includes(saveStatusList, false);
    var areResponsesEmpty = saveStatusList.length === 0;
    var isMatchingResponseTrue = saveStatusList[index];
    return isMatchingResponseTrue || areThereMoreAttributesThanResponses && areAllResponsesTrue || areResponsesEmpty;
  }

  /**
   * Return 0 if all overrides saved successfully, -1 if all failed and n > 0 for a mixed status
   */
  function cleanUpAfterSave(overrideData, saveStatusList, gridId, scenarioName, skipUpdatingGridValues) {
    var saveToScenario = scenarioName && scenarioName !== scenarioConstants.PUBLISHED;
    var index = 0;
    var failedCount = 0;
    var cellsToCleanUp = [];
    _.forEach(overrideData, function (row) {
      _.forEach(row._old, function (v, key) {
        var cellData = {
          rowId: row.originalRowId
        };
        if (isInvalidOverrideField(key)) {
          return;
        }
        if (isSaveStatusCorrect(saveStatusList, index)) {
          var currentValue = handleZeroValue(row, key);
          var typeColumnName = getValueTypeColumn(key);
          if (currentValue === '' && row.hasOwnProperty(typeColumnName)) {
            cellData.columnName = typeColumnName;
            cellData.value = constants.DEFAULT_TYPE;
            if (saveToScenario) {
              _.unset(row, 'customClasses.' + typeColumnName);
            }
          } else {
            cellData.columnName = key;
            cellData.value = currentValue;
          }
          if (saveToScenario) {
            if (currentValue === '') {
              _.unset(row, 'customClasses.' + key);
            } else {
              _.set(row, 'customClasses.' + key, 'user-modified');
            }
          }
        } else {
          cellData.columnName = key;
          cellData.value = v;
          failedCount++;
        }
        cellsToCleanUp.push(cellData);
        index++;
      });
      cellsToCleanUp.push({
        rowId: row.originalRowId,
        columnName: '_original',
        value: undefined
      });
      if (saveToScenario) {
        row.userScenarioModified = _.chain(row.customClasses).values().includes('user-modified').value();
      }
    });
    if (!skipUpdatingGridValues) {
      $rootScope.$broadcast('grid:setMultipleCellsValue', gridId, cellsToCleanUp);
    }
    return failedCount !== 0 && failedCount === saveStatusList.length ? -1 : failedCount;
  }
  function stripSegClass(key) {
    return key.replace(constants.STRIP_SEG_CLASS, '');
  }
  return {
    getFlowType: getFlowType,
    getEffectiveFieldName: getEffectiveFieldName,
    getBaseFieldName: getBaseFieldName,
    getRootFieldName: getRootFieldNamePublic,
    getOriginalFieldName: getOriginalFieldName,
    getValueType: getValueTypePublic,
    getTypeValue: getTypeValuePublic,
    getValues: getValues,
    getValueTypeColumn: getValueTypeColumn,
    getRtpField: getRtpField,
    getDemandField: getDemandField,
    getAdjacentOverrideKey: getAdjacentOverrideKey,
    handleZeroValue: handleZeroValue,
    prefixNestedField: prefixNestedField,
    isInvalidOverrideField: isInvalidOverrideField,
    isEffective: isEffective,
    isUserField: isUserField,
    isValueType: isValueType,
    isRtpField: isRtpField,
    isManuallyControlled: isManuallyControlled,
    isUserSegmentLimit: isUserSegmentLimit,
    isUserSegmentLimitType: isUserSegmentLimitType,
    handleSegmentLimitType: handleSegmentLimitType,
    authLinkType: authLinkType,
    cleanUpAfterSave: cleanUpAfterSave,
    overrideMaxType: overrideMaxType,
    overrideMinType: overrideMinType,
    validateStartRtpOverrides: validateStartRtpOverrides,
    isValidStartRtpOverride: isValidStartRtpOverride,
    isAuthOverride: isAuthOverride,
    stripSegClass: stripSegClass
  };
};
OverridesUtilsService.$inject = ['$rootScope', 'OverridesConstants', 'ScenarioConstants'];
module.exports = OverridesUtilsService;